import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'

export interface StripeInvoiceDto {
  id: string
  number: string | null
  created: string
  amountDue: number
  amountPaid: number
  currency: string
  status: 'draft' | 'open' | 'paid' | 'void' | 'uncollectible'
  hostedInvoiceUrl: string | null
  invoicePdfUrl: string | null
}

export function useQueryInvoices(companyId: string | null | undefined, limit = 24) {
  return useQuery<StripeInvoiceDto[]>({
    queryKey: ['subscription.invoices', companyId, limit],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/config-api/${companyId}/subscription/invoices`, {
        params: { limit },
      })
      return data.invoices ?? []
    },
    enabled: !!companyId,
    staleTime: 60_000,
  })
}
